import { createContractRequest } from './helper';
export const getOffers = createContractRequest({
    route: '/contract/offers',
    method: 'get',
    source: 'data',
});
